export default __webpack_public_path__ + "static/media/Sudan.917de00b.png";